<template>
  <h1>Oh dear...something went wrong.</h1>
</template>

<script>
export default {
  name: 'ErrorPage',
};
</script>
